"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCellLabel = exports.TableCellContent = exports.TitleBarContentContainer = exports.TableCellContentContainer = exports.TableCellContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-confusing-arrow, indent */
var TableCellContainer = _styledComponents.default.div.withConfig({
  displayName: "TableCellstyles__TableCellContainer",
  componentId: "sc-96vju9-0"
})(["border-right:", ";&:first-child{border-left:", ";}width:100%;flex:1 1 ", ";text-align:", ";min-height:", ";", ""], function (props) {
  return props.hasErrors ? "1px solid ".concat(props.theme.c_foreground_danger) : "1px solid ".concat(props.theme.c_foreground_gridLines);
}, function (props) {
  return props.hasErrors ? "1px solid ".concat(props.theme.c_foreground_danger) : "1px solid ".concat(props.theme.c_foreground_gridLines);
}, function (props) {
  return "".concat(props.basis, "%");
}, function (props) {
  return props.align;
}, function (props) {
  return props.titleBar ? '1.5rem' : '2.5rem';
}, function (props) {
  return props.titleBar && "background-color: ".concat(props.theme.c_foreground_gridLines, ";");
});

exports.TableCellContainer = TableCellContainer;

var TableCellContentContainer = _styledComponents.default.div.withConfig({
  displayName: "TableCellstyles__TableCellContentContainer",
  componentId: "sc-96vju9-1"
})(["padding:.3rem ", ";height:100%;display:flex;flex-direction:column;justify-content:center;align-content:center;"], function (props) {
  return props.theme.standardPadding;
});

exports.TableCellContentContainer = TableCellContentContainer;
var TitleBarContentContainer = (0, _styledComponents.default)(TableCellContentContainer).withConfig({
  displayName: "TableCellstyles__TitleBarContentContainer",
  componentId: "sc-96vju9-2"
})(["font-size:", ";font-weight:", ";color:", ";"], function (props) {
  return props.theme.fontSmall;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.c_foreground_default;
});
exports.TitleBarContentContainer = TitleBarContentContainer;

var TableCellContent = _styledComponents.default.span.withConfig({
  displayName: "TableCellstyles__TableCellContent",
  componentId: "sc-96vju9-3"
})(["line-height:", ";font-size:", ";font-weight:", ";color:", ";"], function (props) {
  return props.theme.fontSmall;
}, function (props) {
  return props.theme.fontSmall;
}, function (props) {
  return props.isBold ? props.theme.primaryHeavy : props.theme.primaryNormal;
}, function (props) {
  return props.theme.c_foreground_default;
});

exports.TableCellContent = TableCellContent;

var TableCellLabel = _styledComponents.default.span.withConfig({
  displayName: "TableCellstyles__TableCellLabel",
  componentId: "sc-96vju9-4"
})(["line-height:", ";font-size:", ";font-weight:", ";color:", ";"], function (props) {
  return props.theme.fontSmall;
}, function (props) {
  return props.theme.fontMinuscule;
}, function (props) {
  return props.isBold ? props.theme.primaryHeavy : props.theme.primaryNormal;
}, function (props) {
  return props.theme.c_foreground_default;
});

exports.TableCellLabel = TableCellLabel;